import { Component, Input, OnInit } from '@angular/core';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { CommonModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { Navigator } from 'src/app/services/routing/navigator';

@Component({
  selector: 'app-deposit-all-methods',
  templateUrl: './deposit-all-methods.component.html',
  styleUrls: ['./deposit-all-methods.component.scss'],
})
export class DepositAllMethodsComponent implements OnInit {

  @Input() navigateBackPage: "string";

  public labels: DepositMainLabels;

  constructor(
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
  ){
    this.labels = new CommonModel();
  }

  ngOnInit(){
  }
  
  ngAfterViewInit(){
    this.cashierContentService.getPageConfig('common').then((response: DepositMainLabels) => {
        this.labels = response;
    });
  }

  navigateTo(page: string) {
		return this.navigator.navigateTo(page);
	}

}
